import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Title = styled.div`
  color: ${Colors.GS1000};
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
`

export const Subtitle = styled.div`
  color: ${Colors.GS600};
  text-align: center;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 15.6px */
`

export const Stack = styled.div<{ space: number }>`
  display: flex;
  align-items: center;
  flex-direction: column;

  & > * + * {
    margin-top: ${({ space }) => space}px;
  }
`

export const Container = styled.div`
  margin: 40px 0;
`
